<template>

	<section>

		<div class="masthead">
			<slot name="masthead-image" />
			<div class="headline">
				<h1><slot name="headline" /></h1>
				<h3><slot name="sub-headline" /></h3>
				<div class="content">
					<p><slot name="content" /></p>
				</div>
			</div>
		</div>

	</section>

</template>

<script>

	export default {
		name: "masthead"
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";

	.masthead {
		display:flex; flex:1; align-items:center; justify-content:center; position:relative;
		img {
			max-width:none; max-height:100%; min-width:100%; min-height:100%; object-fit:cover; position:absolute; top:0; left:0; bottom:0; right:0; z-index:-1;
		}
	}
	.headline {
		color:#ffffff; max-width:112.7rem; font-weight:400;
		a {
			color:inherit;
		}
	}

	.content {
		max-width:85.8rem; margin:0 auto;
		@include media(small, large) {
			line-height:1.3;
		}
	}
	.center {
		.headline {
			text-align:center;
		}
	}
	h1 {
		font-size:3rem; line-height:1.16; margin-bottom:1.5rem; font-weight:400; text-transform:uppercase;
		@include media(large) {
			font-size:6rem; margin-bottom:3.4rem;
		}
	}
	h3 {
		font-size:2.2rem; line-height:1.13; font-weight:400;
	}

	body.embed-mode {
		.headline {
			color:inherit;
			a {
				color:#0071BC;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/layouts/layoutA/masthead.vue